import React from "react";
import { updateReduxAction } from "../../redux/actions";
import { store } from "../../redux/store";
export function getBuildingTypeOptions(){
  const options = getBuildingTypes();
  if (options){
    return options.map((item: string, index: number) => (
      <option key={index} value={item}>
        {item}
      </option>
    ));
  }
  return <option></option>;
}
function getBuildingTypes(){
  return [
    "Restaurant",
    "Store",
    "Office/Commercial",
    "Schools K-12",
    "College/University",
    "Hospital",
    "Healthcare",
    "Detention",
    "WWT Plant",
    "Government/Municipal",
    "Large Area Amusement",
    "Other Amusement",
    "Manufacturing/Industrial",
    "Data Center",
    "Residential"
  ];
}
export function getStateOptions(country: string) {
  const options = getStates(country);
  if (options) {
    return options.map((item: string, index: number) => (
      <option key={index} value={item}>
        {item}
      </option>
    ));
  }
  return <option></option>;
}
function getStates(country: string) {
  if (country === "USA") {
    return [
      "AK",
      "AL",
      "AR",
      "AZ",
      "CA",
      "CO",
      "CT",
      "DC",
      "DE",
      "FL",
      "GA",
      "HI",
      "IA",
      "ID",
      "IL",
      "IN",
      "KS",
      "KY",
      "LA",
      "MA",
      "MD",
      "ME",
      "MI",
      "MN",
      "MO",
      "MS",
      "MT",
      "NC",
      "ND",
      "NE",
      "NH",
      "NJ",
      "NM",
      "NV",
      "NY",
      "OH",
      "OK",
      "OR",
      "PA",
      "RI",
      "SC",
      "SD",
      "TN",
      "TX",
      "UT",
      "VA",
      "VT",
      "WA",
      "WI",
      "WV",
      "WY"
    ];
  }
  if (country === "Canada") {
    return ["AB", "BC", "MB", "NB", "NL", "NS", "NU", "NT", "ON", "PE", "QC", "SK", "YT"];
  } else {
    return [""];
  }
}
export function formatCurrency(amount: number) {
  return amount.toLocaleString("en-US", {
    style: "currency",
    currency: "USD"
  });
}
export function formatPhone(value: string) {
  // Remove all non-digits
  const digits = value.replace(/\D/g, "").slice(0, 10);

  const part1 = digits.slice(0, 3);
  const part2 = digits.slice(3, 6);
  const part3 = digits.slice(6, 10);

  if (digits.length <= 3) return part1;
  if (digits.length <= 6) return `${part1}-${part2}`;

  return `${part1}-${part2}-${part3}`;
};
export function formatDate(date: Date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}
export function addOneDay(startDate: Date){
  const result = new Date(startDate);
  result.setDate(result.getDate() + 1);
  return result;
}
export const allowedFileExtensions = [
  ".pdf",
  ".doc",
  ".docx",
  ".png",
  ".jpg",
  ".jpeg",
  ".step",
  ".dwg"
];

export const FACTORY_REQUEST_EMAIL_VALIDATION_MESSAGE =
  "Innovent email addresses cannot be added. Additional recipients are intended for members of your office who should receive Factory Request status updates.";

const RESTRICTED_FACTORY_REQUEST_EMAIL_DOMAINS = [
  "innoventair.com",
  "unisoncomfort.com",
  "greenheck.com",
  "greenheckgroup.com",
  "valentair.com"
];

export function isValidFactoryRequestEmail(email: string) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
}

export function isRestrictedFactoryRequestEmail(email: string) {
  const normalizedEmail = email.trim().toLowerCase();
  const atIndex = normalizedEmail.lastIndexOf("@");
  const domain = atIndex >= 0 ? normalizedEmail.substring(atIndex + 1) : "";

  return RESTRICTED_FACTORY_REQUEST_EMAIL_DOMAINS.includes(domain);
}

export function getFactoryRequestEmailValidationMessage(email: string) {
  if (!isValidFactoryRequestEmail(email)) {
    return "Invalid Email Address";
  }

  return isRestrictedFactoryRequestEmail(email)
    ? FACTORY_REQUEST_EMAIL_VALIDATION_MESSAGE
    : "";
}

export function hasRestrictedFactoryRequestEmail(emails: string[] | undefined) {
  return (emails || []).some(isRestrictedFactoryRequestEmail);
}

export function showNeedsRecalcModal(recalcUnits:string[]){
  console.log(recalcUnits);
  const factoryRequestUnits = (store.getState() as any).reduxFactoryRequestUnits;
  const modalData = {
    title: 'Design Validation Required',
    content: <div>
      <p>The following unit(s) require attention before this Factory Request can be submitted.</p>
      <p>Complete any missing design information or recalculate the design as needed.</p>
      {recalcUnits.map((unitId: string) => {
            const matchingUnit = factoryRequestUnits.find(
              (unit: any) => unit.id === unitId
            );

            return (
              <li key={unitId} className="modal-list-item">
                <b>
                  {matchingUnit?.unitTag ?? ""} ({unitId})
                </b>
              </li>
            );
          })}
      <p><b>To continue:</b></p>
      <ul>
        <li>Go to the <b>Optimize Design</b> tab to complete the design and update the calculations for each unit.</li>
        <li>If any unit designs are no longer needed, go to the <b>Job Files</b> tab and change the unit status to <b>Inactive</b>.</li>
      </ul>

    </div>
  };
  store.dispatch(updateReduxAction("UPDATE_MODALS", {
    showModal: true,
    modalType: 'ModalPopup',
    modalId: 'submit-factory-request-validate',
    modalData: modalData,
    hideCancelBtn: true  
  }));
}
export function needsRecalc(mods:any, allUnits:any): string[] {
  
  const RECALC_LEVELS = new Set([
    "FullRecalc",
    "FullUnitStructureRebuild",
  ]);

  const unitLookup = Object.fromEntries(
    allUnits.map((unit: any) => [unit.id, unit])
  );

  const result = new Set<string>();

  mods.forEach((mod: any) => {
    mod.ModifiedUnits.forEach((unitId: string) => {
      if (unitId === "All") {
        allUnits.forEach((unit: any) => {
          if (RECALC_LEVELS.has(unit.needsReCalcLevel)) {
            result.add(`${unit.unitTag} ${unit.id}`);
          }
        });
      } else {
        const unit = unitLookup[unitId];

        if (unit && RECALC_LEVELS.has(unit.needsReCalcLevel)) {
          result.add(`${unit.unitTag} ${unit.id}`);
        }
      }
    });
  });

  return Array.from(result);
}
export function needsRecalcRelease(mods: string[], allUnits: any[]): string[] {
  const RECALC_LEVELS = new Set([
    "FullRecalc",
    "FullUnitStructureRebuild",
  ]);

  const unitLookup = Object.fromEntries(
    allUnits.map((unit: any) => [unit.id, unit])
  );

  const result = new Set<string>();

  mods.forEach((unitId: string) => {
    if (unitId === "All") {
      allUnits.forEach((unit: any) => {
        if (RECALC_LEVELS.has(unit.needsReCalcLevel)) {
          result.add(`${unit.unitTag} ${unit.id}`);
        }
      });
    } else {
      const unit = unitLookup[unitId];

      if (unit && RECALC_LEVELS.has(unit.needsReCalcLevel)) {
        result.add(`${unit.unitTag} ${unit.id}`);
      }
    }
  });
  return Array.from(result);
}
